function togglePropertyIdsContainer(user_role) {
  if (user_role == 'content_manager') {
    $('#property_ids_container').show();
    $('#user_property_ids').removeAttr('disabled');
    $('input[name="user[property_ids][]"]').removeAttr('disabled');
  } else {
    $('#property_ids_container').hide();
    $('#user_property_ids').attr('disabled', 'disabled');
    $('input[name="user[property_ids][]"]').attr('disabled', 'disabled');
  }
}

function initSummernote() {
  // Load Summernote dynamically when needed
  if (typeof $ !== 'undefined') {
    if (!$.fn.summernote) {
      // Dynamically load Summernote script
      const script = document.createElement('script');
      script.src = '/summernote.min.js';
      script.onload = function() {
        if ($.fn.summernote) {
          $('[data-provider="summernote"]').summernote({
            toolbar : [
              ['style', ['bold', 'italic']],
              ['para', ['ul', 'ol']],
              ['insert', ['link', 'hr']]
            ],
            minHeight: 300
          });
        }
      };
      document.head.appendChild(script);
    } else {
      $('textarea.summernote').summernote({
        toolbar : [
          ['style', ['bold', 'italic']],
          ['para', ['ul', 'ol']],
          ['insert', ['link', 'hr']]
        ],
        minHeight: 300
      });
    }
  } else {
    console.warn('jQuery not available');
  }
}

function switchOneOfFields() {
  $('.switched').each(function(_, element) {
    var object = $(element);
    var fieldset = object.closest('fieldset');
    var selectedType = fieldset.find(':input.sections_type').val();

    if (object.data('type') == selectedType) {
      if (object.is('div')) {
        object.show();
        object.find(':input').removeAttr('disabled');
      } else if (object.is('a')) {
        object.show();
      } else {
        object.closest('.form-group').show();
        object.removeAttr('disabled');
      }
    } else {
      if (object.is('div')) {
        object.hide();
        object.find(':input').attr('disabled', 'disabled');
      } else if (object.is('a')) {
        object.hide();
      } else {
        object.closest('.form-group').hide();
        object.attr('disabled', 'disabled');
      }
    }
  });
}

function filterTable() {
  var input, filter, table, tr, td, i;
  input = document.getElementById('filter_input');
  filter = input.value.toUpperCase();
  table = document.getElementById('filtered_table');
  tr = table.getElementsByTagName('tr');

  for (i = 0; i < tr.length; i++) {
    td = tr[i].getElementsByTagName('td')[0];
    if (td) {
      if (td.innerHTML.toUpperCase().indexOf(filter) > -1) {
        tr[i].style.display = '';
      } else {
        tr[i].style.display = 'none';
      }
    }
  }
}

function resetFilteredTable() {
  var table, tr, i;
  table = document.getElementById('filtered_table');
  tr = table.getElementsByTagName('tr');

  for (i = 0; i < tr.length; i++) {
    tr[i].style.display = '';
  }
}

function initTimepicker() {
  $('.timepicker').each(function(_, element) {
    var time = $(element).data('time');
    $(element).wickedpicker({
      now: time,
      timeSeparator: ':',
      zeroPadded: true
    });
    if (typeof time === 'undefined' || !time) {
      $(element).val('');
    }
  });
}

function ready() {
  if ($('#property_ids_container').length > 0) {
    togglePropertyIdsContainer($('#user_role').val());

    $(document).on('change', '#user_role', function() {
      togglePropertyIdsContainer($(this).val());
    });
  }

  initSummernote();

  $(document).on('nested:fieldAdded', function(event){
    initSummernote();
    switchOneOfFields();
    initTimepicker();
  });

  $(document).on('change', '.sections_type', function() {
    switchOneOfFields();
  });
  switchOneOfFields();

  $('form').on('click', '.add_brand_background_images', function(event) {
    $(".brand_background_images").append('<div class="row image-container"><div class="col-sm-6"><input class="form-control array-element image-url" type="text" value="" name="brand[background_images][]" /></div><div class="col-sm-6"><img class="image-preview" /></div></div>');
    return event.preventDefault();
  });

  $('form').on('keyup', '.image-url', function(event) {
    $(this).closest('.image-container').find('img').attr('src', $(this).val());
  });

  initTimepicker();

  $('form').on('click', '.sync-from-cq5', function(event) {
    var fieldId = $(event.target).data('field-id');
    var fieldLabel = $('label[for="' + fieldId + '"]').text();
    $('#cq5-url-label').html('URL for ' + fieldLabel.replace('*', ''));
    $('#cq5-field-id').val(fieldId);
    $('#cq5-url').val('');
    $('.cq5-sync-error-container').hide();
    $('#sync-cq5-modal').modal();
    return event.preventDefault();
  });

  $(function() {
    $(document)
      .ajaxStart(function() {
        $('.cq5-sync-error-container').hide();
        $('#loading').show();
        $('#cq5-submit').prop('disabled', true);
      })
      .ajaxStop(function() {
        $('#loading').hide();
        $('#cq5-submit').prop('disabled', false);
    });
  });

  $(document).on('keyup', '#filter_input', filterTable);

  $('form').on('click', '#save_and_deploy', function() {
    $('#deploy').val('true');
    $(this).closest('form').submit();
  });

  $(document).on('change', '.js-information-page-type', function() {
    const pageType = $(this)
    const contentUrl = pageType.closest('fieldset').find('.form-group.property_information_pages_content_url')
    if (pageType.val() == 'My Residence Deep Link') {
      contentUrl.addClass('hidden')
    } else {
      contentUrl.removeClass('hidden')
    }
  })

  $('.js-localization-raw-field').prop('disabled', true);
};

// Handle both turbo:load (after navigation) and turbo:render (after cache restore)
setTimeout(() => {
  if (typeof $ !== 'undefined') {
    $(document).on("turbo:load turbo:render", ready);

    // Call ready immediately if page is already interactive/complete
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      ready();
    }
  }
}, 0);

function showLocalizationRawJSON() {
  $('#localization_normalized_fieldset').hide();
  $('#localization_raw_data_fieldset').fadeIn('slow');
  $('.js-localization-normalized-field').prop('disabled', true);
  $('.js-localization-raw-field').prop('disabled', false);
  return false;
}

function showLocalizationNormalizedFieldset() {
  $('#localization_raw_data_fieldset').hide();
  $('#localization_normalized_fieldset').fadeIn('slow');
  $('.js-localization-raw-field').prop('disabled', true);
  $('.js-localization-normalized-field').prop('disabled', false);
  return false;
}

export { ready, showLocalizationNormalizedFieldset, showLocalizationRawJSON };
